export const allowedProtocols = ['http:', 'https:'];
